import { render } from "./SkillNode.vue?vue&type=template&id=d4b8b2e2&scoped=true"
import script from "./SkillNode.vue?vue&type=script&lang=js"
export * from "./SkillNode.vue?vue&type=script&lang=js"

import "./SkillNode.vue?vue&type=style&index=0&id=d4b8b2e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b8b2e2"]])

export default __exports__